import { useEffect, useState } from "react";

function useCurrentPosition() {
  const [data, setData] = useState({ latitudeData: null, longitudeData: null, timezone: null, address: null });
  sessionStorage.setItem("RestLatLong", JSON.stringify(data))
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      setData({
        latitudeData: position.coords.latitude,
        longitudeData: position.coords.longitude,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
      });

    });
  }, []);


  return data;
}













export default useCurrentPosition;
